/*
  DO NOT EDIT - THIS FILE IS AUTO-GENERATED VIA "npm run assemble-af-standard"
*/
export const variablesCss = `
:root, :host {
  --font-family-montserrat: Montserrat, sans-serif;
  --airframe-color-neutral-white: #FFFFFF;
  --airframe-color-neutral-white-opacity-10: rgba(255, 255, 255, 0.1);
  --airframe-color-neutral-white-opacity-5: rgba(255, 255, 255, 0.05);
  --airframe-color-neutral-white-opacity-75: rgba(255, 255, 255, 0.75);
  --airframe-color-neutral-grey-10: #EFEFEF;
  --airframe-color-neutral-grey-10-opacity-50: rgba(239, 239, 239, 0.5);
  --airframe-color-neutral-grey-20: #DADADA;
  --airframe-color-neutral-grey-20-opacity-50: rgba(218, 218, 218, 0.5);
  --airframe-color-neutral-grey-30: #B3B3B3;
  --airframe-color-neutral-grey-40: #999999;
  --airframe-color-neutral-grey-45: #8A8A8A;
  --airframe-color-neutral-grey-45-opacity-75: rgba(138, 138, 138, 0.75);
  --airframe-color-neutral-grey-50: #717171;
  --airframe-color-neutral-grey-60: #5B6162;
  --airframe-color-neutral-grey-70: #3F4444;
  --airframe-color-neutral-grey-70-opacity-50: rgba(63, 68, 68, 0.5);
  --airframe-color-neutral-grey-80: #2D2926;
  --airframe-color-neutral-grey-80-opacity-80: rgba(45, 41, 38, 0.8);
  --airframe-color-neutral-grey-90: #110F0F;
  --airframe-color-neutral-black: #000000;
  --airframe-color-neutral-black-opacity-10: rgba(0, 0, 0, 0.1);
  --airframe-color-neutral-black-opacity-5: rgba(0, 0, 0, 0.05);
  --airframe-color-disabled-dark-on-light: #B3B3B3;
  --airframe-color-disabled-light-on-light: #EFEFEF;
  --airframe-color-disabled-mid-on-light: #DADADA;
  --airframe-color-disabled-dark-on-dark: #3F4444;
  --airframe-color-disabled-light-on-dark: #8A8A8A;
  --airframe-color-disabled-mid-on-dark: rgba(138, 138, 138, 0.75);
  --airframe-color-border-on-light: #717171;
  --airframe-color-border-hover-on-light: #999999;
  --airframe-color-border-disabled-on-light: #B3B3B3;
  --airframe-color-border-on-dark: #999999;
  --airframe-color-border-hover-on-dark: #B3B3B3;
  --airframe-color-border-disabled-on-dark: rgba(138, 138, 138, 0.75);
  --airframe-color-foreground-disabled-on-dark: rgba(138, 138, 138, 0.75);
  --airframe-color-foreground-disabled-on-light: #8A8A8A;
  --airframe-color-foreground-normal-on-dark: #FFFFFF;
  --airframe-color-foreground-normal-on-light: #2D2926;
  --airframe-color-foreground-subtle-on-dark: #B3B3B3;
  --airframe-color-foreground-subtle-on-light: rgba(138, 138, 138, 0.75);
  --airframe-color-foreground-focus: #0084D4;
  --airframe-color-background-disabled-on-dark: #3F4444;
  --airframe-color-background-disabled-on-light: #EFEFEF;
  --airframe-color-background-high-contrast-on-dark: #FFFFFF;
  --airframe-color-background-high-contrast-on-light: #2D2926;
  --airframe-color-background-low-contrast-on-dark: #3F4444;
  --airframe-color-background-low-contrast-on-light: #DADADA;
  --airframe-color-background-mid-contrast-on-dark: #DADADA;
  --airframe-color-background-mid-contrast-on-light: #2D2926;
  --airframe-color-primary-normal: #00856C;
  --airframe-color-primary-dark: #00705C;
  --airframe-color-primary-extra-dark: #005242;
  --airframe-color-primary-light: #00AB8D;
  --airframe-color-primary-extra-light: #00C19F;
  --airframe-color-primary-extra-extra-light: #B6E1DA;
  --airframe-color-primary-extra-light-opacity-10: rgba(0, 193, 159, 0.1);
  --airframe-color-accent: #E0004D;
  --airframe-color-accent-dark: #CD063E;
  --airframe-color-accent-extra-dark: #BA0C2F;
  --airframe-color-accent-extra-light: #FF1A74;
  --airframe-color-accent-light: #FF005A;
  --airframe-color-accent-normal: #E0004D;
  --airframe-color-status-danger-dark: #CA1D26;
  --airframe-color-status-danger-extra-dark: #BA1B23;
  --airframe-color-status-danger-extra-light: #FFCCCC;
  --airframe-color-status-danger-mid-light: #FF8F8F;
  --airframe-color-status-danger-light: #FF3333;
  --airframe-color-status-danger-normal: #EB0000;
  --airframe-color-status-info-dark: #00519A;
  --airframe-color-status-info-extra-dark: #001E60;
  --airframe-color-status-info-extra-light: #B6FFFF;
  --airframe-color-status-info-light: #69C6FF;
  --airframe-color-status-info-normal: #0075DB;
  --airframe-color-status-success-dark: #197032;
  --airframe-color-status-success-extra-dark: #0E401C;
  --airframe-color-status-success-extra-light: #E5F9EB;
  --airframe-color-status-success-light: #98E8AF;
  --airframe-color-status-success-normal: #24A148;
  --airframe-color-status-warning-dark: #E3AD20;
  --airframe-color-status-warning-extra-dark: #C69214;
  --airframe-color-status-warning-extra-light: #FEF9E9;
  --airframe-color-status-warning-light: #FFE395;
  --airframe-color-status-warning-normal: #FFC72C;
  --airframe-color-brand-green: #0084D4;
  --airframe-color-brand-red: #E0004D;
  --airframe-color-brand-yellow: #FFC72C;
  --airframe-color-chart-primary-1: #00856C;
  --airframe-color-chart-primary-1-opacity-50: rgba(0, 133, 108, 0.5);
  --airframe-color-chart-primary-2:#82BFB3;
  --airframe-color-chart-primary-2-opacity-50: rgba(130, 191, 179, 0.5);
  --airframe-color-chart-primary-3: #004438;
  --airframe-color-chart-primary-3-opacity-50: rgba(0, 68, 56, 0.5);
  --airframe-color-chart-primary-4: #8DBE7E;
  --airframe-color-chart-primary-4-opacity-50: rgba(141, 190, 126, 0.5);
  --airframe-color-chart-primary-5: #005646;
  --airframe-color-chart-primary-5-opacity-50: rgba(0, 86, 70, 0.5);
  --airframe-color-chart-primary-6: #5AC2A3;
  --airframe-color-chart-primary-6-opacity-50: rgba(90, 194, 163, 0.5);
  --airframe-color-chart-primary-border: #004438;
  --airframe-color-chart-secondary-1: #00519A;
  --airframe-color-chart-secondary-2: #5FA9D3;
  --airframe-color-chart-secondary-3: #002B99;
  --airframe-color-chart-secondary-4: #5F82C8;
  --airframe-color-chart-secondary-5: #031185;
  --airframe-color-chart-secondary-6: #6193FF;
  --airframe-color-chart-secondary-border: #00519A;
  --airframe-color-chart-accessibility-1: #00856C;
  --airframe-color-chart-accessibility-2: #001E60;
  --airframe-color-chart-accessibility-3: #E0004D;
  --airframe-color-chart-accessibility-4: #FFCA38;
  --airframe-color-chart-accessibility-5: #3C1A3D;
  --airframe-color-chart-accessibility-6: #FF8200;
  --airframe-color-chart-accessibility-7: #00519A;
  --airframe-color-chart-accessibility-8: #05C3DE;
  --airframe-color-chart-accessibility-9: #9B3342;
  --airframe-color-chart-accessibility-10: #2DC84D;
  --airframe-color-chart-accessibility-11: #74550B;
  --airframe-color-chart-accessibility-12: #B2ABE2;
  --airframe-space-xxxs: 0.125rem;
  --airframe-space-xxs: 0.25rem;
  --airframe-space-xs: 0.5rem;
  --airframe-space-sm: 0.75rem;
  --airframe-space-md: 1rem;
  --airframe-space-lg: 1.5rem;
  --airframe-space-xl: 2rem;
  --airframe-space-xxl: 2.5rem;
  --airframe-space-xxxl: 3rem;
  --airframe-breakpoint-xs: 0px;
  --airframe-breakpoint-vs: 320px;
  --airframe-breakpoint-sm: 640px;
  --airframe-breakpoint-md: 1024px;
  --airframe-breakpoint-xm: 1280px;
  --airframe-breakpoint-lg: 1440px;
  --airframe-breakpoint-xl: 1920px;
}
`;

export const resetCss = `
/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */
/* Document
  ========================================================================== */
/**
* 1. Correct the line height in all browsers.
* 2. Prevent adjustments of font size after orientation changes in iOS.
*/
html {
  line-height: 1.15;
  /* 1 */
  -webkit-text-size-adjust: 100%;
  /* 2 */
}

/* Sections
  ========================================================================== */
/**
* Remove the margin in all browsers.
*/
body {
  margin: 0;
}

/**
* Render the 'main' element consistently in IE.
*/
main {
  display: block;
}

/**
* Correct the font size and margin on 'h1' elements within 'section' and
* 'article' contexts in Chrome, Firefox, and Safari.
*/
h1 {
  font-size: 2em;
  margin: 0.67em 0;
}

/* Grouping content
  ========================================================================== */
/**
* 1. Add the correct box sizing in Firefox.
* 2. Show the overflow in Edge and IE.
*/
hr {
  box-sizing: content-box;
  /* 1 */
  height: 0;
  /* 1 */
  overflow: visible;
  /* 2 */
}

/**
* 1. Correct the inheritance and scaling of font size in all browsers.
* 2. Correct the odd 'em' font sizing in all browsers.
*/
pre {
  font-family: monospace, monospace;
  /* 1 */
  font-size: 1em;
  /* 2 */
}

/* Text-level semantics
  ========================================================================== */
/**
* Remove the gray background on active links in IE 10.
*/
a {
  background-color: transparent;
}

/**
* 1. Remove the bottom border in Chrome 57-
* 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
*/
abbr[title] {
  border-bottom: none;
  /* 1 */
  text-decoration: underline;
  /* 2 */
  text-decoration: underline dotted;
  /* 2 */
}

/**
* Add the correct font weight in Chrome, Edge, and Safari.
*/
b,
strong {
  font-weight: bolder;
}

/**
* 1. Correct the inheritance and scaling of font size in all browsers.
* 2. Correct the odd 'em' font sizing in all browsers.
*/
code,
kbd,
samp {
  font-family: monospace, monospace;
  /* 1 */
  font-size: 1em;
  /* 2 */
}

/**
* Add the correct font size in all browsers.
*/
small {
  font-size: 80%;
}

/**
* Prevent 'sub' and 'sup' elements from affecting the line height in
* all browsers.
*/
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/* Embedded content
  ========================================================================== */
/**
* Remove the border on images inside links in IE 10.
*/
img {
  border-style: none;
}

/* Forms
  ========================================================================== */
/**
* 1. Change the font styles in all browsers.
* 2. Remove the margin in Firefox and Safari.
*/
button,
input,
optgroup,
select,
textarea {
  font-family: inherit;
  /* 1 */
  font-size: 100%;
  /* 1 */
  line-height: 1.15;
  /* 1 */
  margin: 0;
  /* 2 */
}

/**
* Show the overflow in IE.
* 1. Show the overflow in Edge.
*/
button,
input {
  /* 1 */
  overflow: visible;
}

/**
* Remove the inheritance of text transform in Edge, Firefox, and IE.
* 1. Remove the inheritance of text transform in Firefox.
*/
button,
select {
  /* 1 */
  text-transform: none;
}

/**
* Correct the inability to style clickable types in iOS and Safari.
*/
button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}

/**
* Remove the inner border and padding in Firefox.
*/
button::-moz-focus-inner,
[type=button]::-moz-focus-inner,
[type=reset]::-moz-focus-inner,
[type=submit]::-moz-focus-inner {
  border-style: none;
  padding: 0;
}

/**
* Restore the focus styles unset by the previous rule.
*/
button:-moz-focusring,
[type=button]:-moz-focusring,
[type=reset]:-moz-focusring,
[type=submit]:-moz-focusring {
  outline: 1px dotted ButtonText;
}

/**
* Correct the padding in Firefox.
*/
fieldset {
  padding: 0.35em 0.75em 0.625em;
}

/**
* 1. Correct the text wrapping in Edge and IE.
* 2. Correct the color inheritance from 'fieldset' elements in IE.
* 3. Remove the padding so developers are not caught out when they zero out
*    'fieldset' elements in all browsers.
*/
legend {
  box-sizing: border-box;
  /* 1 */
  color: inherit;
  /* 2 */
  display: table;
  /* 1 */
  max-width: 100%;
  /* 1 */
  padding: 0;
  /* 3 */
  white-space: normal;
  /* 1 */
}

/**
* Add the correct vertical alignment in Chrome, Firefox, and Opera.
*/
progress {
  vertical-align: baseline;
}

/**
* Remove the default vertical scrollbar in IE 10+.
*/
textarea {
  overflow: auto;
}

/**
* 1. Add the correct box sizing in IE 10.
* 2. Remove the padding in IE 10.
*/
[type=checkbox],
[type=radio] {
  box-sizing: border-box;
  /* 1 */
  padding: 0;
  /* 2 */
}

/**
* Correct the cursor style of increment and decrement buttons in Chrome.
*/
[type=number]::-webkit-inner-spin-button,
[type=number]::-webkit-outer-spin-button {
  height: auto;
}

/**
* 1. Correct the odd appearance in Chrome and Safari.
* 2. Correct the outline style in Safari.
*/
[type=search] {
  -webkit-appearance: textfield;
  /* 1 */
  outline-offset: -2px;
  /* 2 */
}

/**
* Remove the inner padding in Chrome and Safari on macOS.
*/
[type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}

/**
* 1. Correct the inability to style clickable types in iOS and Safari.
* 2. Change font properties to 'inherit' in Safari.
*/
::-webkit-file-upload-button {
  -webkit-appearance: button;
  /* 1 */
  font: inherit;
  /* 2 */
}

/* Interactive
  ========================================================================== */
/*
* Add the correct display in Edge, IE 10+, and Firefox.
*/
details {
  display: block;
}

/*
* Add the correct display in all browsers.
*/
summary {
  display: list-item;
}

/* Misc
  ========================================================================== */
/**
* Add the correct display in IE 10+.
*/
template {
  display: none;
}

/**
* Add the correct display in IE 10.
*/
[hidden] {
  display: none;
}

/* http://meyerweb.com/eric/tools/css/reset/ 
  v2.0 | 20110126
  License: none (public domain)
*/
html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed,
figure, figcaption, footer, header, hgroup,
menu, nav, output, ruby, section, summary,
time, mark, audio, video {
  margin: 0;
  padding: 0;
  border: 0;
  font: inherit;
  font-size: 100%;
  vertical-align: baseline;
}

/* HTML5 display-role reset for older browsers */
article, aside, details, figcaption, figure,
footer, header, hgroup, menu, nav, section {
  display: block;
}

ol, ul {
  list-style: none;
}

blockquote, q {
  quotes: none;
}

blockquote:before, blockquote:after,
q:before, q:after {
  content: "";
  content: none;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}
`;

export const standardCss = `
html {
  box-sizing: border-box;
  font-size: 100%;
}

*,
*::before,
*::after {
  box-sizing: inherit;
}

body {
  font-family: "Montserrat", sans-serif;
  font-size: 0.875rem;
  font-weight: 500;
  letter-spacing: 0.003125rem;
  line-height: 1.25rem;
  margin: 0;
  padding: 0;
}

.airframe-normal-onlight {
  color: #2D2926;
}

.airframe-subtle-onlight {
  color: #5B6162;
}

@media print, screen {
  h6,
.heading6 {
    font-size: 1rem;
    font-weight: 500;
    letter-spacing: 0.003125rem;
    line-height: 1.5rem;
    margin: 0;
  }

  h5,
.heading5 {
    font-size: 1.125rem;
    font-weight: 500;
    letter-spacing: 0.00375rem;
    line-height: 1.5rem;
    margin: 0;
  }

  h4,
.heading4 {
    font-size: 1.25rem;
    font-weight: 500;
    letter-spacing: 0.004375rem;
    line-height: 1.5rem;
    margin: 0;
  }

  h3,
.heading3 {
    font-size: 1.5rem;
    font-weight: 500;
    letter-spacing: 0.005rem;
    line-height: 1.5rem;
    margin: 0;
  }

  h2,
.heading2 {
    font-size: 2rem;
    font-weight: 300;
    letter-spacing: 0.006875rem;
    line-height: 2.5rem;
    margin: 0;
  }

  h1,
.heading1 {
    font-size: 2.5rem;
    font-weight: 300;
    letter-spacing: 0.008125rem;
    line-height: 3rem;
    margin: 0;
  }

  .hero {
    font-size: 3.75rem;
    font-weight: 300;
    letter-spacing: 0.0125rem;
    line-height: 4.5rem;
    margin: 0;
  }

  label {
    font-size: 0.875rem;
    font-weight: bold;
    letter-spacing: 0.003125rem;
    line-height: 1.5rem;
    margin: 0;
  }

  p {
    font-size: 1rem;
    font-weight: 500;
    letter-spacing: 0.003125rem;
    line-height: 1.5rem;
    margin: 0;
  }

  button {
    font-size: 0.875rem;
    font-weight: bold;
    letter-spacing: 0.058125rem;
    line-height: 1.25rem;
    text-align: center;
    margin: 0;
  }

  .airframe-caption {
    font-size: 0.875rem;
    font-weight: 300;
    letter-spacing: 0.003125rem;
    line-height: 1rem;
    text-align: center;
    margin: 0;
  }

  .airframe-footnote {
    font-size: 0.75rem;
    font-weight: 500;
    letter-spacing: 0.0025rem;
    line-height: 1rem;
    margin: 0;
  }
}
@media print, screen and (min-width: 80rem) {
  .hero {
    font-size: 5rem;
    font-weight: 300;
    letter-spacing: 0.016875rem;
    line-height: 5rem;
    margin: 0;
  }

  h1,
.heading1 {
    font-size: 3.75rem;
    font-weight: 300;
    letter-spacing: 0.0125rem;
    line-height: 4.5rem;
    margin: 0;
  }

  h2,
.heading2 {
    font-size: 2.5rem;
    font-weight: 300;
    letter-spacing: 0.008125rem;
    line-height: 3rem;
    margin: 0;
  }

  h3,
.heading3 {
    font-size: 2rem;
    font-weight: 500;
    letter-spacing: 0.006875rem;
    line-height: 2.5rem;
    margin: 0;
  }

  h4,
.heading4 {
    font-size: 1.5rem;
    font-weight: 500;
    letter-spacing: 0.005rem;
    line-height: 2rem;
    margin: 0;
  }

  h5,
.heading5 {
    font-size: 1.25rem;
    font-weight: 500;
    letter-spacing: 0.004375rem;
    line-height: 1.5rem;
    margin: 0;
  }

  h6,
.heading6 {
    font-size: 1.125rem;
    font-weight: bold;
    letter-spacing: 0.00375rem;
    line-height: 1.5rem;
    margin: 0;
  }
}
.airframe__button {
  appearance: none;
  background: none transparent;
  border: 0.0625rem solid transparent;
  border-radius: 0.1875rem;
  color: #2D2926;
  cursor: pointer;
  display: inline-block;
  font-family: "Montserrat", sans-serif;
  font-size: 0.875rem;
  font-weight: 700;
  letter-spacing: 0.058rem;
  line-height: 1.125rem;
  min-width: 8rem;
  padding: 0.625rem;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
  transition: background-color 100ms ease 0s, border-color 100ms ease 0s, transform 100ms ease 0s, box-shadow 100ms ease 0s;
  user-select: none;
}
.airframe__button:focus {
  outline: none !important;
  border-color: transparent;
  border-radius: 0.1875rem;
  box-shadow: 0 0 0 0.0625rem white, 0 0 0 0.1875rem #0084D4;
}
.airframe__button:active {
  transform: translateY(1px);
}
.airframe__button:disabled, .airframe__button[disabled], .airframe__button.is-disabled, .airframe__button.is-disabled:hover {
  background-color: #EFEFEF;
  border-color: transparent;
  color: #8A8A8A;
  cursor: not-allowed;
  transform: translateY(0);
}
.airframe__button[class*=-on-dark]:disabled, .airframe__button[class*=-on-dark][disabled], .airframe__button[class*=-on-dark].is-disabled, .airframe__button[class*=-on-dark].is-disabled:hover {
  background-color: #3F4444;
  color: rgba(138, 138, 138, 0.75);
}
.airframe__button--primary, .airframe__button--primary-on-dark {
  background-color: #00856C;
  border-color: #00856C;
  color: #FFFFFF;
}
.airframe__button--primary:hover, .airframe__button--primary-on-dark:hover {
  background-color: #00C19F;
  border-color: #00C19F;
}
.airframe__button--primary:active, .airframe__button--primary-on-dark:active {
  background-color: #005242;
  border-color: #005242;
  color: #00AB8D;
}
.airframe__button--secondary {
  border-color: #00856C;
  color: #00856C;
}
.airframe__button--secondary:hover {
  border-color: #00C19F;
  color: #00C19F;
}
.airframe__button--secondary:active {
  background-color: rgba(0, 193, 159, 0.1);
  border-color: #00705C;
  color: #00705C;
}
.airframe__button--secondary-on-dark {
  border-color: #FFFFFF;
  color: #FFFFFF;
}
.airframe__button--secondary-on-dark:hover {
  border-color: #00C19F;
  color: #00C19F;
}
.airframe__button--secondary-on-dark:active {
  background-color: rgba(0, 193, 159, 0.1);
  border-color: #00705C;
  color: #00856C;
}
.airframe__button--plain {
  color: #00856C;
}
.airframe__button--plain:hover {
  background-color: rgba(0, 0, 0, 0.1);
  color: #00C19F;
}
.airframe__button--plain:active {
  background-color: rgba(0, 0, 0, 0.05);
  color: #00AB8D;
}
.airframe__button--flat {
  color: #00705C;
  font-weight: 500;
  letter-spacing: 0.003125rem;
  line-height: 1rem;
  border: none;
  min-width: 0;
  min-height: 0;
  padding: 0;
  text-transform: none;
}
.airframe__button--flat:hover {
  color: #00C19F;
}
.airframe__button--flat:active {
  color: #00AB8D;
}
.airframe__button--flat:disabled, .airframe__button--flat[disabled], .airframe__button--flat.is-disabled {
  background: none;
  color: #8A8A8A;
}
.airframe__button--plain-on-dark {
  color: #00AB8D;
}
.airframe__button--plain-on-dark:hover {
  background-color: rgba(255, 255, 255, 0.1);
}
.airframe__button--plain-on-dark:active {
  background-color: rgba(255, 255, 255, 0.05);
}
.airframe__button--neutral:hover {
  background-color: rgba(0, 0, 0, 0.1);
}
.airframe__button--neutral:active {
  background-color: rgba(0, 0, 0, 0.05);
}
.airframe__button--neutral-on-dark {
  color: #FFFFFF;
}
.airframe__button--neutral-on-dark:hover {
  background-color: rgba(255, 255, 255, 0.1);
}
.airframe__button--neutral-on-dark:active {
  background-color: rgba(255, 255, 255, 0.05);
}
.airframe__button--danger {
  background-color: #EB0000;
  color: #FFFFFF;
}
.airframe__button--danger:hover {
  background-color: #FF3333;
  border-color: #FF3333;
}
.airframe__button--danger:active {
  background-color: #BA1B23;
  border-color: #BA1B23;
  color: #FFCCCC;
}
.airframe__button--danger-on-dark {
  background-color: #EB0000;
  color: #FFFFFF;
}
.airframe__button--danger-on-dark:hover {
  background-color: #FF3333;
  border-color: #FF3333;
}
.airframe__button--danger-on-dark:active {
  color: #FFCCCC;
  background-color: #BA1B23;
  border-color: #BA1B23;
}
.airframe__button:hover, .airframe__button:active {
  box-shadow: none !important;
}

.airframe__link {
  color: #00856C;
  cursor: pointer;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  text-decoration: none;
  letter-spacing: 0.05px;
}
.airframe__link:visited {
  color: #00856C;
}
.airframe__link:hover {
  color: #00C19F;
  text-decoration: underline;
}
.airframe__link:active {
  color: #2D2926;
  text-decoration: none;
}
.airframe__link:focus {
  outline: none !important;
  border-color: transparent;
  border-radius: 0.1875rem;
  box-shadow: 0 0 0 0.0625rem white, 0 0 0 0.1875rem #0084D4;
}
.airframe__link:disabled, .airframe__link[disabled], .airframe__link.is-disabled, .airframe__link.is-disabled:hover {
  color: rgba(138, 138, 138, 0.75);
  cursor: not-allowed;
  text-decoration: none;
}
.airframe__link--on-dark, .airframe__link--on-dark:active, .airframe__link--on-dark:hover, .airframe__link--on-dark:visited {
  color: #FFFFFF;
}
.airframe__link--on-dark:disabled, .airframe__link--on-dark[disabled], .airframe__link--on-dark.is-disabled, .airframe__link--on-dark.is-disabled:hover, .airframe__link--on-dark:active:disabled, .airframe__link--on-dark:active[disabled], .airframe__link--on-dark:active.is-disabled, .airframe__link--on-dark:active.is-disabled:hover, .airframe__link--on-dark:hover:disabled, .airframe__link--on-dark:hover[disabled], .airframe__link--on-dark:hover.is-disabled, .airframe__link--on-dark:hover.is-disabled:hover, .airframe__link--on-dark:visited:disabled, .airframe__link--on-dark:visited[disabled], .airframe__link--on-dark:visited.is-disabled, .airframe__link--on-dark:visited.is-disabled:hover {
  color: #8A8A8A;
}
.airframe__link--inline, .airframe__link--inline-on-dark {
  text-decoration: underline;
}
.airframe__link--inline:disabled, .airframe__link--inline[disabled], .airframe__link--inline.is-disabled, .airframe__link--inline.is-disabled:hover, .airframe__link--inline-on-dark:disabled, .airframe__link--inline-on-dark[disabled], .airframe__link--inline-on-dark.is-disabled, .airframe__link--inline-on-dark.is-disabled:hover {
  text-decoration: underline;
  color: rgba(138, 138, 138, 0.75);
}
.airframe__link--inline:focus {
  outline: none !important;
  border-color: transparent;
  border-radius: 0.1875rem;
  box-shadow: 0 0 0 0.0625rem white, 0 0 0 0.1875rem #0084D4;
}
.airframe__link--inline:visited {
  color: #00519A;
}
.airframe__link--inline:hover {
  color: #00C19F;
}
.airframe__link--inline:active {
  color: #2D2926;
}
.airframe__link--inline-on-dark {
  color: #00AB8D;
}
.airframe__link--inline-on-dark:visited {
  color: #69C6FF;
}
.airframe__link--inline-on-dark:hover {
  color: #00C19F;
}
.airframe__link--inline-on-dark:active {
  color: #FFFFFF;
}
.airframe__link:hover, .airframe__link:active {
  box-shadow: none !important;
}

.airframe__checkbox {
  height: 1rem;
  width: 1rem;
  border: 0.0625rem solid #717171;
  box-sizing: border-box;
  border-radius: 0.125rem;
  background-color: #FFFFFF;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  appearance: none;
}
.airframe__checkbox:hover {
  border: 0.0625rem solid #00AB8D;
}
.airframe__checkbox:focus {
  border: 0.0625rem solid #717171;
  outline: none !important;
  border-color: transparent;
  border-radius: 0.1875rem;
  box-shadow: 0 0 0 0.0625rem white, 0 0 0 0.1875rem #0084D4;
}
.airframe__checkbox:checked:before {
  width: 0.25rem;
  height: 0.5625rem;
  margin: 0.1875rem 0.375rem;
  border-bottom: 0.125rem solid #FFFFFF;
  border-right: 0.125rem solid #FFFFFF;
  transform: rotate(45deg);
}
.airframe__checkbox:before,
.airframe__checkbox .indeterminate:before {
  content: "";
  display: block;
}
.airframe__checkbox.indeterminate:checked:before {
  border-bottom: none !important;
  transform: rotate(90deg);
}
.airframe__checkbox:disabled, .airframe__checkbox[disabled], .airframe__checkbox:disabled:hover, .airframe__checkbox[disabled]:hover {
  background-color: #EFEFEF;
  border: 1px solid #B3B3B3;
  cursor: not-allowed;
  transform: translateY(0);
}
.airframe__checkbox:disabled:checked, .airframe__checkbox[disabled]:checked, .airframe__checkbox:disabled:checked:hover, .airframe__checkbox[disabled]:checked:hover {
  background: #B3B3B3;
  border: none;
}
.airframe__checkbox:disabled:checked:before, .airframe__checkbox[disabled]:checked:before {
  border-bottom: 0.125rem solid #EFEFEF;
  border-right: 0.125rem solid #EFEFEF;
}
.airframe__checkbox[class*=-on-dark]:disabled, .airframe__checkbox[class*=-on-dark][disabled], .airframe__checkbox[class*=-on-dark]:disabled:hover, .airframe__checkbox[class*=-on-dark][disabled]:hover {
  border: 0.0625rem solid rgba(138, 138, 138, 0.75);
  background-color: #3F4444;
}
.airframe__checkbox[class*=-on-dark]:disabled:checked, .airframe__checkbox[class*=-on-dark][disabled]:checked, .airframe__checkbox[class*=-on-dark]:disabled:checked:hover, .airframe__checkbox[class*=-on-dark][disabled]:checked:hover {
  background: rgba(138, 138, 138, 0.75);
  border: none;
}
.airframe__checkbox--primary:hover, .airframe__checkbox--primary-on-dark:hover {
  border: 0.0625rem solid #00AB8D;
}
.airframe__checkbox--primary:hover:checked, .airframe__checkbox--primary-on-dark:hover:checked {
  background-color: #00AB8D;
}
.airframe__checkbox--primary:checked, .airframe__checkbox--primary-on-dark:checked {
  background: #00856C;
  color: #FFFFFF;
  border: none;
}
.airframe__checkbox--error, .airframe__checkbox--error:hover {
  border: 0.0625rem solid #BA1B23;
}
.airframe__checkbox--error:checked, .airframe__checkbox--error:hover:checked {
  background-color: #BA1B23;
}
.airframe__checkbox--error-on-dark, .airframe__checkbox--error-on-dark:hover {
  border: 0.0625rem solid #FF8F8F;
}
.airframe__checkbox--error-on-dark:checked, .airframe__checkbox--error-on-dark:hover:checked {
  background-color: #FF8F8F;
}
.airframe__checkbox--error:checked:before, .airframe__checkbox--error-on-dark:checked:before {
  margin: 0.125rem 0.3125rem;
}

.airframe__radiogroup {
  display: block;
  position: relative;
  padding-left: 1.4375rem;
  cursor: pointer;
  height: 1.75rem;
  width: 6.75rem;
  color: #2D2926;
  font-family: "Montserrat", sans-serif;
  font-size: 0.875rem;
  font-weight: 500;
  letter-spacing: 0.003125rem;
  line-height: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.25rem;
  padding-right: 1rem;
}
.airframe__radiogroup input:first-of-type {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}
.airframe__radiogroup span:first-of-type {
  position: absolute;
  top: 12;
  left: 0;
  height: 1rem;
  width: 1rem;
  background-color: #FFFFFF;
  border-radius: 50% !important;
  border: 0.0625rem solid #717171;
  box-sizing: border-box;
}
.airframe__radiogroup span:first-of-type:hover {
  border: 0.0625rem solid #00AB8D;
  background-color: #EFEFEF;
}
.airframe__radiogroup input:first-of-type:checked ~ span:first-of-type {
  background-color: #00856C;
  border: none;
}
.airframe__radiogroup input:hover:checked ~ span:first-of-type {
  background-color: #00AB8D;
}
.airframe__radiogroup input:focus ~ span:first-of-type {
  outline: none !important;
  border-color: transparent;
  border-radius: 0.1875rem;
  box-shadow: 0 0 0 0.0625rem white, 0 0 0 0.1875rem #0084D4;
}
.airframe__radiogroup span:first-of-type:after {
  top: 0.3125rem;
  left: 0.3125rem;
  width: 0.375rem;
  height: 0.375rem;
  border-radius: 50%;
  background: #FFFFFF;
  content: "";
  position: absolute;
  display: none;
}
.airframe__radiogroup input:first-of-type:checked ~ span:first-of-type:after {
  display: block;
}
.airframe__radiogroup_title {
  height: 1.5rem;
  width: 6.5rem;
  color: #2D2926;
  font-size: 0.875rem;
  font-weight: bold;
  letter-spacing: 0.003125rem;
  line-height: 1.5rem;
  text-align: left;
}

.airframe__toggle {
  position: relative;
  display: inline-block;
  height: 1rem;
  width: 2rem;
  border-radius: 6.25rem;
}
.airframe__toggle span:first-of-type {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #B3B3B3;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 2.125rem;
}
.airframe__toggle span:first-of-type:before {
  position: absolute;
  content: "";
  left: 0.125rem;
  bottom: 0.125rem;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  height: 0.75rem;
  width: 0.75rem;
  border-radius: 6.25rem;
  background-color: #FFFFFF;
}
.airframe__toggle input:first-of-type {
  display: none;
}
.airframe__toggle input:first-of-type:checked + span:first-of-type {
  background-color: #00856C;
}
.airframe__toggle input:first-of-type:hover:checked + span:first-of-type {
  background-color: #00AB8D;
}
.airframe__toggle input:first-of-type:hover + span:first-of-type {
  background-color: #DADADA;
}
.airframe__toggle input:first-of-type:focus + span:first-of-type {
  box-sizing: border-box;
  height: 1.375rem;
  width: 2.375rem;
  border: 0.125rem solid #0084D4;
  border-radius: 0.625rem;
  background-color: rgba(255, 255, 255, 0.75);
}
.airframe__toggle input:first-of-type:checked + span:first-of-type:before {
  -webkit-transform: translateX(1rem);
  -ms-transform: translateX(1rem);
  transform: translateX(1rem);
}

.airframe__icon-button {
  background: none transparent;
  border: 0.0625rem solid transparent;
  border-radius: 0.1875rem;
  color: #00856C;
  cursor: pointer;
  display: inline-block;
  height: 2.5rem;
  width: 2.5rem;
  transition: background-color 100ms ease 0s, border-color 100ms ease 0s, transform 100ms ease 0s;
  font-size: 1rem;
}
.airframe__icon-button:focus {
  outline: none !important;
  border-color: transparent;
  border-radius: 0.1875rem;
  box-shadow: 0 0 0 0.0625rem white, 0 0 0 0.1875rem #0084D4;
}
.airframe__icon-button:hover {
  color: #00C19F;
  background-color: rgba(0, 133, 108, 0.1);
}
.airframe__icon-button:active {
  color: #005242;
  background-color: #DADADA;
  transform: translateY(1px);
}
.airframe__icon-button:hover, .airframe__icon-button:active {
  box-shadow: none !important;
}
.airframe__icon-button:disabled, .airframe__icon-button.is-disabled, .airframe__icon-button.is-disabled:hover {
  color: #8A8A8A;
  background-color: transparent;
  cursor: not-allowed;
  transform: translateY(0);
}

label.airframe__textfield {
  font-weight: 700;
  font-size: 0.875rem;
  line-height: 1.5rem;
  letter-spacing: 0.003125rem;
  color: #2D2926;
}
label.airframe__textfield div:first-of-type {
  font-weight: 300;
  line-height: 1rem;
  font-size: 0.875rem;
  letter-spacing: 0.003125rem;
  color: #2D2926;
  padding-top: 4px;
}
label.airframe__textfield input:first-of-type {
  margin-top: 6px;
  display: block;
  font-family: "Montserrat", sans-serif;
  outline: 0;
  height: 2.5rem;
  padding-left: 0.75rem;
  font-size: 0.875rem;
  font-weight: 500;
  box-sizing: border-box;
  border-radius: 0.125rem;
  border-width: 0.0625rem;
  border-color: #717171;
  border-style: solid;
}
label.airframe__textfield input:first-of-type::placeholder {
  font-weight: 300;
  color: #5B6162;
}
label.airframe__textfield input:first-of-type:focus {
  border-color: #0084D4;
}
label.airframe__textfield input:first-of-type:hover {
  background-color: #EFEFEF;
  border-color: #00AB8D;
}
label.airframe__textfield input:first-of-type:disabled, label.airframe__textfield input:first-of-type:disabled:hover {
  background-color: #EFEFEF;
  color: #8A8A8A;
  border-color: #717171;
  cursor: not-allowed;
}
label.airframe__textfield input:first-of-type.input-validation-error {
  border-color: #BA1B23;
}

.airframe__textfield:not(label) {
  font-family: "Montserrat", sans-serif;
  outline: 0;
  height: 2.5rem;
  padding-left: 0.75rem;
  font-size: 0.875rem;
  font-weight: 500;
  box-sizing: border-box;
  border-radius: 0.125rem;
  border-width: 0.0625rem;
  border-color: #717171;
  border-style: solid;
}
.airframe__textfield:not(label)::placeholder {
  font-weight: 300;
  color: #5B6162;
}
.airframe__textfield:not(label):focus {
  border-color: #0084D4;
}
.airframe__textfield:not(label):hover {
  background-color: #EFEFEF;
  border-color: #00AB8D;
}
.airframe__textfield:not(label):disabled, .airframe__textfield:not(label):disabled:hover {
  background-color: #EFEFEF;
  color: #8A8A8A;
  border-color: #717171;
  cursor: not-allowed;
}
.airframe__textfield:not(label).input-validation-error {
  border-color: #BA1B23;
}

.airframe__spinner-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 12.5rem;
  height: 12.5rem;
}
.airframe__spinner-icon {
  height: 3.125rem;
  width: 3.125rem;
  border-width: 0.25rem;
  border-color: #DADADA;
  border-top-color: #00856C;
  border-style: solid;
  border-radius: 50%;
  animation: spinner 1s infinite linear;
  -webkit-animation: spinner 1s infinite linear;
}
@media (min-width: 640px) {
  .airframe__spinner-icon {
    height: 4.6875rem;
    width: 4.6875rem;
    border-width: 0.375rem;
  }
}
@media (min-width: 1280px) {
  .airframe__spinner-icon {
    height: 6.25rem;
    width: 6.25rem;
    border-width: 0.5rem;
  }
}
.airframe__spinner-text {
  padding: 0.625rem;
}
@media (max-width: 640px) {
  .airframe__spinner-text {
    font-size: 80%;
  }
}
@media (max-width: 1280px) {
  .airframe__spinner-text {
    font-size: 90%;
  }
}

@keyframes spinner {
  from {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
.airframe__navigation-tabs {
  margin: auto;
  margin-bottom: 0.125rem;
  padding: 0;
  justify-content: center;
  display: flex;
}
.airframe__navigation-tabs a {
  margin: 0 0.375rem 0 0.375rem;
  text-decoration: none;
  color: #5B6162;
  cursor: pointer;
  font-size: 1.125rem;
}
.airframe__navigation-tabs a:hover {
  color: #5B6162;
  border-bottom: 2px solid #DADADA;
}
.airframe__navigation-tabs a:active {
  color: #5B6162;
  border-bottom: 2px solid #999999;
}
.airframe__navigation-tabs a.current-tab {
  border-bottom: 2px solid #00856C !important;
  color: black !important;
  cursor: context-menu;
}
`;

export const variables = {
  'font-family-montserrat': 'Montserrat, sans-serif',
  'airframe-color-neutral-white': '#FFFFFF',
  'airframe-color-neutral-white-opacity-10': 'rgba(255, 255, 255, 0.1)',
  'airframe-color-neutral-white-opacity-5': 'rgba(255, 255, 255, 0.05)',
  'airframe-color-neutral-white-opacity-75': 'rgba(255, 255, 255, 0.75)',
  'airframe-color-neutral-grey-10': '#EFEFEF',
  'airframe-color-neutral-grey-10-opacity-50': 'rgba(239, 239, 239, 0.5)',
  'airframe-color-neutral-grey-20': '#DADADA',
  'airframe-color-neutral-grey-20-opacity-50': 'rgba(218, 218, 218, 0.5)',
  'airframe-color-neutral-grey-30': '#B3B3B3',
  'airframe-color-neutral-grey-40': '#999999',
  'airframe-color-neutral-grey-45': '#8A8A8A',
  'airframe-color-neutral-grey-45-opacity-75': 'rgba(138, 138, 138, 0.75)',
  'airframe-color-neutral-grey-50': '#717171',
  'airframe-color-neutral-grey-60': '#5B6162',
  'airframe-color-neutral-grey-70': '#3F4444',
  'airframe-color-neutral-grey-70-opacity-50': 'rgba(63, 68, 68, 0.5)',
  'airframe-color-neutral-grey-80': '#2D2926',
  'airframe-color-neutral-grey-80-opacity-80': 'rgba(45, 41, 38, 0.8)',
  'airframe-color-neutral-grey-90': '#110F0F',
  'airframe-color-neutral-black': '#000000',
  'airframe-color-neutral-black-opacity-10': 'rgba(0, 0, 0, 0.1)',
  'airframe-color-neutral-black-opacity-5': 'rgba(0, 0, 0, 0.05)',
  'airframe-color-disabled-dark-on-light': '#B3B3B3',
  'airframe-color-disabled-light-on-light': '#EFEFEF',
  'airframe-color-disabled-mid-on-light': '#DADADA',
  'airframe-color-disabled-dark-on-dark': '#3F4444',
  'airframe-color-disabled-light-on-dark': '#8A8A8A',
  'airframe-color-disabled-mid-on-dark': 'rgba(138, 138, 138, 0.75)',
  'airframe-color-border-on-light': '#717171',
  'airframe-color-border-hover-on-light': '#999999',
  'airframe-color-border-disabled-on-light': '#B3B3B3',
  'airframe-color-border-on-dark': '#999999',
  'airframe-color-border-hover-on-dark': '#B3B3B3',
  'airframe-color-border-disabled-on-dark': 'rgba(138, 138, 138, 0.75)',
  'airframe-color-foreground-disabled-on-dark': 'rgba(138, 138, 138, 0.75)',
  'airframe-color-foreground-disabled-on-light': '#8A8A8A',
  'airframe-color-foreground-normal-on-dark': '#FFFFFF',
  'airframe-color-foreground-normal-on-light': '#2D2926',
  'airframe-color-foreground-subtle-on-dark': '#B3B3B3',
  'airframe-color-foreground-subtle-on-light': 'rgba(138, 138, 138, 0.75)',
  'airframe-color-foreground-focus': '#0084D4',
  'airframe-color-background-disabled-on-dark': '#3F4444',
  'airframe-color-background-disabled-on-light': '#EFEFEF',
  'airframe-color-background-high-contrast-on-dark': '#FFFFFF',
  'airframe-color-background-high-contrast-on-light': '#2D2926',
  'airframe-color-background-low-contrast-on-dark': '#3F4444',
  'airframe-color-background-low-contrast-on-light': '#DADADA',
  'airframe-color-background-mid-contrast-on-dark': '#DADADA',
  'airframe-color-background-mid-contrast-on-light': '#2D2926',
  'airframe-color-primary-normal': '#00856C',
  'airframe-color-primary-dark': '#00705C',
  'airframe-color-primary-extra-dark': '#005242',
  'airframe-color-primary-light': '#00AB8D',
  'airframe-color-primary-extra-light': '#00C19F',
  'airframe-color-primary-extra-extra-light': '#B6E1DA',
  'airframe-color-primary-extra-light-opacity-10': 'rgba(0, 193, 159, 0.1)',
  'airframe-color-accent': '#E0004D',
  'airframe-color-accent-dark': '#CD063E',
  'airframe-color-accent-extra-dark': '#BA0C2F',
  'airframe-color-accent-extra-light': '#FF1A74',
  'airframe-color-accent-light': '#FF005A',
  'airframe-color-accent-normal': '#E0004D',
  'airframe-color-status-danger-dark': '#CA1D26',
  'airframe-color-status-danger-extra-dark': '#BA1B23',
  'airframe-color-status-danger-extra-light': '#FFCCCC',
  'airframe-color-status-danger-mid-light': '#FF8F8F',
  'airframe-color-status-danger-light': '#FF3333',
  'airframe-color-status-danger-normal': '#EB0000',
  'airframe-color-status-info-dark': '#00519A',
  'airframe-color-status-info-extra-dark': '#001E60',
  'airframe-color-status-info-extra-light': '#B6FFFF',
  'airframe-color-status-info-light': '#69C6FF',
  'airframe-color-status-info-normal': '#0075DB',
  'airframe-color-status-success-dark': '#197032',
  'airframe-color-status-success-extra-dark': '#0E401C',
  'airframe-color-status-success-extra-light': '#E5F9EB',
  'airframe-color-status-success-light': '#98E8AF',
  'airframe-color-status-success-normal': '#24A148',
  'airframe-color-status-warning-dark': '#E3AD20',
  'airframe-color-status-warning-extra-dark': '#C69214',
  'airframe-color-status-warning-extra-light': '#FEF9E9',
  'airframe-color-status-warning-light': '#FFE395',
  'airframe-color-status-warning-normal': '#FFC72C',
  'airframe-color-brand-green': '#0084D4',
  'airframe-color-brand-red': '#E0004D',
  'airframe-color-brand-yellow': '#FFC72C',
  'airframe-color-chart-primary-1': '#00856C',
  'airframe-color-chart-primary-1-opacity-50': 'rgba(0, 133, 108, 0.5)',
  'airframe-color-chart-primary-2': '#82BFB3',
  'airframe-color-chart-primary-2-opacity-50': 'rgba(130, 191, 179, 0.5)',
  'airframe-color-chart-primary-3': '#004438',
  'airframe-color-chart-primary-3-opacity-50': 'rgba(0, 68, 56, 0.5)',
  'airframe-color-chart-primary-4': '#8DBE7E',
  'airframe-color-chart-primary-4-opacity-50': 'rgba(141, 190, 126, 0.5)',
  'airframe-color-chart-primary-5': '#005646',
  'airframe-color-chart-primary-5-opacity-50': 'rgba(0, 86, 70, 0.5)',
  'airframe-color-chart-primary-6': '#5AC2A3',
  'airframe-color-chart-primary-6-opacity-50': 'rgba(90, 194, 163, 0.5)',
  'airframe-color-chart-primary-border': '#004438',
  'airframe-color-chart-secondary-1': '#00519A',
  'airframe-color-chart-secondary-2': '#5FA9D3',
  'airframe-color-chart-secondary-3': '#002B99',
  'airframe-color-chart-secondary-4': '#5F82C8',
  'airframe-color-chart-secondary-5': '#031185',
  'airframe-color-chart-secondary-6': '#6193FF',
  'airframe-color-chart-secondary-border': '#00519A',
  'airframe-color-chart-accessibility-1': '#00856C',
  'airframe-color-chart-accessibility-2': '#001E60',
  'airframe-color-chart-accessibility-3': '#E0004D',
  'airframe-color-chart-accessibility-4': '#FFCA38',
  'airframe-color-chart-accessibility-5': '#3C1A3D',
  'airframe-color-chart-accessibility-6': '#FF8200',
  'airframe-color-chart-accessibility-7': '#00519A',
  'airframe-color-chart-accessibility-8': '#05C3DE',
  'airframe-color-chart-accessibility-9': '#9B3342',
  'airframe-color-chart-accessibility-10': '#2DC84D',
  'airframe-color-chart-accessibility-11': '#74550B',
  'airframe-color-chart-accessibility-12': '#B2ABE2',
  'airframe-space-xxxs': '0.125rem',
  'airframe-space-xxs': '0.25rem',
  'airframe-space-xs': '0.5rem',
  'airframe-space-sm': '0.75rem',
  'airframe-space-md': '1rem',
  'airframe-space-lg': '1.5rem',
  'airframe-space-xl': '2rem',
  'airframe-space-xxl': '2.5rem',
  'airframe-space-xxxl': '3rem',
  'airframe-breakpoint-xs': '0px',
  'airframe-breakpoint-vs': '320px',
  'airframe-breakpoint-sm': '640px',
  'airframe-breakpoint-md': '1024px',
  'airframe-breakpoint-xm': '1280px',
  'airframe-breakpoint-lg': '1440px',
  'airframe-breakpoint-xl': '1920px',
};

export default variables;
